










import { Component, Mixins, Prop } from "vue-property-decorator";
import Context from "@/mixins/context";
import { IClient } from "@/models/clients";
import { IInvoice } from "@/models/invoices";
import { DataModules } from "@/store/modules/data";
import _ from "@/boot/lodash";
import { ClientRoutes } from "@/data/enums/router";

@Component
export default class UInvoiceLink extends Mixins(Context) {
  // Props

  @Prop({ required: true })
  public invoiceId!: IInvoice["id"];

  @Prop({ required: false, default: undefined })
  public clientId?: IClient["id"];

  @Prop({ default: true })
  public isProgrammatic!: boolean;

  // Getters
  public get link() {
    if (this.isMockClientContext) return this.mockClientRouterLink();
    if (!this.isAdmin) return this.clientRouterLink();
    if (this.clientId) return this.adminRouterLink();
    if (this.isProgrammatic) return this.adminPreviewProgrammaticLink();
    return this.adminPreviewRouterLink();
  }

  // Methods

  public clientRouterLink() {
    return {
      type: "router-link",
      props: {
        to: {
          name: ClientRoutes.INVOICE,
          params: _.pick(this.$props, ["invoiceId"])
        }
      }
    };
  }

  public mockClientRouterLink() {
    return {
      type: "router-link",
      props: {
        to: {
          name: `admin__upmindInvoice`,
          params: _.pick(this.$props, ["invoiceId"])
        }
      }
    };
  }

  public adminRouterLink() {
    return {
      type: "router-link",
      props: {
        to: {
          name: `adminInvoice`,
          params: _.pick(this.$props, ["invoiceId", "clientId"])
        }
      }
    };
  }

  public adminPreviewProgrammaticLink() {
    return {
      type: "a",
      events: {
        click: () =>
          this.$store.dispatch(
            `data/${DataModules.INVOICES}/openPreviewModal`,
            _.pick(this.$props, ["invoiceId"])
          )
      }
    };
  }

  public adminPreviewRouterLink() {
    return {
      type: "router-link",
      props: {
        to: {
          name: `adminInvoicePreview`,
          params: _.pick(this.$props, ["invoiceId"])
        }
      }
    };
  }
}
